﻿export function sliderVideoModal() {
    const videoButtons = Array.from(document.querySelectorAll(".show-video-button"));

    for (var i = 0; i < videoButtons.length; i++) {
        videoButtons[i].onclick = function () {
            var modalType = this.dataset.modalType.toLowerCase();
            var modalLink = this.dataset.modalLink;
            var modalContentElement = document.querySelector(".video-modal-content");
            var modalElement = document.querySelector(".position-modal");

            modalElement.style.visibility = "visible";

            modalContentElement.getElementsByTagName('source')[0].removeAttribute("src");
            modalContentElement.getElementsByTagName('video')[0].width = "0";
            modalContentElement.getElementsByTagName('video')[0].height = "0";
            modalContentElement.getElementsByTagName('video')[0].load();
            modalContentElement.getElementsByTagName('iframe')[0].removeAttribute("src");
            modalContentElement.getElementsByTagName('iframe')[0].width = "0";
            modalContentElement.getElementsByTagName('iframe')[0].height = "0";

            if (modalType === "youtube") {
                modalLink = "https://www.youtube.com/embed/" + modalLink;
                modalContentElement.getElementsByTagName('iframe')[0].src = modalLink;
                modalContentElement.getElementsByTagName('iframe')[0].width = "100%";
                modalContentElement.getElementsByTagName('iframe')[0].height = "100%";
            }
            else {
                modalContentElement.getElementsByTagName('source')[0].src = modalLink;
                modalContentElement.getElementsByTagName('video')[0].removeAttribute("width");
                modalContentElement.getElementsByTagName('video')[0].removeAttribute("height");
                modalContentElement.getElementsByTagName('video')[0].load();
            }

            modalContentElement.getElementsByTagName('button')[0].onclick = function () {
                modalElement.style.visibility = "hidden";
                modalContentElement.getElementsByTagName('source')[0].removeAttribute("src");
                modalContentElement.getElementsByTagName('iframe')[0].removeAttribute("src");
                modalContentElement.getElementsByTagName('iframe')[0].width = "0";
                modalContentElement.getElementsByTagName('iframe')[0].height = "0";
                modalContentElement.getElementsByTagName('video')[0].width = "0";
                modalContentElement.getElementsByTagName('video')[0].height = "0";
                modalContentElement.getElementsByTagName('video')[0].load();
            };
        };
    }
}